// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__0HGLx","container":"Projects_container__Iy6Vg","project":"Projects_project__N2NIf"};